import {useEffect} from 'react'
import {useQueryClient} from 'react-query'
import {useDispatch} from 'react-redux'
import {Navigate, Routes} from 'react-router-dom'
import * as auth from './redux/AuthRedux'

export function Logout() {
  const queryClient = useQueryClient()
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(auth.actions.logout())
    queryClient.removeQueries()
    document.location.reload()
  }, [dispatch, queryClient])

  return (
    <Routes>
      <Navigate to='/auth/login' />
    </Routes>
  )
}
